let custompricing = [
    {
        "type": "printonly",
        "id": 40290702524468,
        "price": "8.00"
    },
    {
        "type": "printonly",
        "id": 40290702557236,
        "price": "10.00"
    },
    {
        "type": "printonly",
        "id": 40290702590004,
        "price": "12.00"
    },
    {
        "type": "printonly",
        "id": 40290702622772,
        "price": "14.00"
    },
    {
        "type": "printonly",
        "id": 40290702655540,
        "price": "16.00"
    },
    {
        "type": "printonly",
        "id": 40290702688308,
        "price": "18.00"
    },
    {
        "type": "printonly",
        "id": 40290702721076,
        "price": "20.00"
    },
    {
        "type": "printonly",
        "id": 40290702753844,
        "price": "22.00"
    },
    {
        "type": "printonly",
        "id": 40290702786612,
        "price": "24.00"
    },
    {
        "type": "printonly",
        "id": 40290702819380,
        "price": "26.00"
    },
    {
        "type": "printonly",
        "id": 40290702852148,
        "price": "28.00"
    },
    {
        "type": "printonly",
        "id": 40290702884916,
        "price": "30.00"
    },
    {
        "type": "printonly",
        "id": 40290702917684,
        "price": "32.00"
    },
    {
        "type": "printonly",
        "id": 40290702950452,
        "price": "34.00"
    },
    {
        "type": "printonly",
        "id": 40290702983220,
        "price": "36.00"
    },
    {
        "type": "printonly",
        "id": 40290703015988,
        "price": "38.00"
    },
    {
        "type": "printonly",
        "id": 40290703048756,
        "price": "40.00"
    },
    {
        "type": "printonly",
        "id": 40290703081524,
        "price": "42.00"
    },
    {
        "type": "printonly",
        "id": 40290703114292,
        "price": "44.00"
    },
    {
        "type": "printonly",
        "id": 40290703147060,
        "price": "46.00"
    },
    {
        "type": "printonly",
        "id": 40290703179828,
        "price": "48.00"
    },
    {
        "type": "printonly",
        "id": 40290703212596,
        "price": "50.00"
    },
    {
        "type": "printonly",
        "id": 40290703245364,
        "price": "52.00"
    },
    {
        "type": "printonly",
        "id": 40290703278132,
        "price": "54.00"
    },
    {
        "type": "printonly",
        "id": 40290703310900,
        "price": "56.00"
    },
    {
        "type": "printonly",
        "id": 40290703343668,
        "price": "58.00"
    },
    {
        "type": "printonly",
        "id": 40290703376436,
        "price": "60.00"
    },
    {
        "type": "printonly",
        "id": 40290703409204,
        "price": "62.00"
    },
    {
        "type": "printonly",
        "id": 40290703441972,
        "price": "64.00"
    },
    {
        "type": "printonly",
        "id": 40290703474740,
        "price": "66.00"
    },
    {
        "type": "printonly",
        "id": 40290703507508,
        "price": "68.00"
    },
    {
        "type": "printonly",
        "id": 40290703540276,
        "price": "70.00"
    },
    {
        "type": "printonly",
        "id": 40290703573044,
        "price": "72.00"
    },
    {
        "type": "printonly",
        "id": 40290703605812,
        "price": "74.00"
    },
    {
        "type": "printonly",
        "id": 40290703638580,
        "price": "76.00"
    },
    {
        "type": "customframe",
        "id": 40292346593332,
        "price": "20.00"
    },
    {
        "type": "customframe",
        "id": 40292341645364,
        "price": "25.00"
    },
    {
        "type": "customframe",
        "id": 40292346626100,
        "price": "30.00"
    },
    {
        "type": "customframe",
        "id": 40292346658868,
        "price": "35.00"
    },
    {
        "type": "customframe",
        "id": 40292346691636,
        "price": "40.00"
    },
    {
        "type": "customframe",
        "id": 40292346724404,
        "price": "45.00"
    },
    {
        "type": "customframe",
        "id": 40292346757172,
        "price": "50.00"
    },
    {
        "type": "customframe",
        "id": 40292346789940,
        "price": "55.00"
    },
    {
        "type": "customframe",
        "id": 40292346822708,
        "price": "60.00"
    },
    {
        "type": "customframe",
        "id": 40292346855476,
        "price": "65.00"
    },
    {
        "type": "customframe",
        "id": 40292346888244,
        "price": "70.00"
    },
    {
        "type": "customframe",
        "id": 40292346921012,
        "price": "75.00"
    },
    {
        "type": "customframe",
        "id": 40292346953780,
        "price": "80.00"
    },
    {
        "type": "customframe",
        "id": 40292346986548,
        "price": "85.00"
    },
    {
        "type": "customframe",
        "id": 40292347019316,
        "price": "90.00"
    },
    {
        "type": "customframe",
        "id": 40292347052084,
        "price": "95.00"
    },
    {
        "type": "customframe",
        "id": 40292347084852,
        "price": "100.00"
    },
    {
        "type": "customframe",
        "id": 40292347117620,
        "price": "105.00"
    },
    {
        "type": "customframe",
        "id": 40292347150388,
        "price": "110.00"
    },
    {
        "type": "customframe",
        "id": 40292347183156,
        "price": "115.00"
    },
    {
        "type": "customframe",
        "id": 40292347215924,
        "price": "120.00"
    },
    {
        "type": "customframe",
        "id": 40292347248692,
        "price": "125.00"
    },
    {
        "type": "customframe",
        "id": 40292347281460,
        "price": "130.00"
    },
    {
        "type": "customframe",
        "id": 40292347314228,
        "price": "135.00"
    },
    {
        "type": "customframe",
        "id": 40292347346996,
        "price": "140.00"
    },
    {
        "type": "customframe",
        "id": 40292347379764,
        "price": "145.00"
    },
    {
        "type": "customframe",
        "id": 40292347412532,
        "price": "150.00"
    },
    {
        "type": "customframe",
        "id": 40292347445300,
        "price": "155.00"
    },
    {
        "type": "customframe",
        "id": 40292347478068,
        "price": "160.00"
    },
    {
        "type": "customframe",
        "id": 40292347510836,
        "price": "165.00"
    },
    {
        "type": "customframe",
        "id": 40292347543604,
        "price": "170.00"
    },
    {
        "type": "customframe",
        "id": 40292347576372,
        "price": "175.00"
    },
    {
        "type": "customframe",
        "id": 40292347609140,
        "price": "180.00"
    },
    {
        "type": "customframe",
        "id": 40292347641908,
        "price": "185.00"
    },
    {
        "type": "customframe",
        "id": 40292347674676,
        "price": "190.00"
    },
    {
        "type": "customframe",
        "id": 40292347707444,
        "price": "195.00"
    },
    {
        "type": "customframe",
        "id": 40292347740212,
        "price": "200.00"
    },
    {
        "type": "customframe",
        "id": 40292347772980,
        "price": "205.00"
    },
    {
        "type": "customframe",
        "id": 40292347805748,
        "price": "210.00"
    },
    {
        "type": "customframe",
        "id": 40292347838516,
        "price": "215.00"
    },
    {
        "type": "customframe",
        "id": 40292347871284,
        "price": "220.00"
    },
    {
        "type": "customframe",
        "id": 40292347904052,
        "price": "225.00"
    },
    {
        "type": "customframe",
        "id": 40292347936820,
        "price": "230.00"
    },
    {
        "type": "customframe",
        "id": 40292347969588,
        "price": "235.00"
    },
    {
        "type": "customframe",
        "id": 40292348002356,
        "price": "240.00"
    },
    {
        "type": "customframe",
        "id": 40292348035124,
        "price": "245.00"
    },
    {
        "type": "customframe",
        "id": 40292348067892,
        "price": "250.00"
    },
    {
        "type": "customframe",
        "id": 40292348100660,
        "price": "255.00"
    },
    {
        "type": "customframe",
        "id": 40292348133428,
        "price": "260.00"
    },
    {
        "type": "customframe",
        "id": 40292348166196,
        "price": "265.00"
    },
    {
        "type": "customframe",
        "id": 40292348198964,
        "price": "270.00"
    },
    {
        "type": "customframe",
        "id": 40292348231732,
        "price": "275.00"
    },
    {
        "type": "customframe",
        "id": 40292348264500,
        "price": "280.00"
    },
    {
        "type": "customframe",
        "id": 40292348297268,
        "price": "285.00"
    },
    {
        "type": "customframe",
        "id": 40292348330036,
        "price": "290.00"
    }
];